import { SiteHeader, SiteFooter } from "../components/landing/SiteChrome";
import { Hero, PricingSection } from "../components/landing/HeroPricing";
import { ProductPreview } from "../components/landing/ProductPreview";
import { HowItWorks, WhySection, TrustSection, FinalCta } from "../components/landing/Sections";

export default function Landing() {
  return (
    <div className="min-h-screen bg-canvas text-ink overflow-x-clip">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:px-4 focus:py-2 focus:rounded-lg focus:bg-brand focus:text-onbrand">Skip to content</a>
      <SiteHeader />
      <main id="main">
        <Hero />
        <HowItWorks />
        <ProductPreview />
        <WhySection />
        <PricingSection />
        <TrustSection />
        <FinalCta />
      </main>
      <SiteFooter />
    </div>
  );
}
